import { render, staticRenderFns } from "./RegistrationConfirmation.vue?vue&type=template&id=a8bbbdc2&scoped=true&"
import script from "./RegistrationConfirmation.vue?vue&type=script&lang=js&"
export * from "./RegistrationConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bbbdc2",
  null
  
)

export default component.exports